export default __webpack_public_path__ + "static/media/livingroom.2024be53.webp";